<dialog
	#dialog
	[attr.aria-label]="label()"
	(cancel)="onCancel($event)"
	(close)="close()"
	class="m-0 h-dvh max-h-none w-screen max-w-none translate-y-full bg-white p-0 transition-[translate,display,overlay] transition-discrete duration-300 ease-out backdrop:bg-transparent open:translate-y-0 starting:open:translate-y-full"
	data-test-id="panel"
>
	@if (closeButton()) {
		<button
			(click)="close()"
			class="btn absolute top-6 right-6 z-10 btn-neutral bg-white"
			data-test-id="panel-close"
			type="button"
		>
			{{ 'global.close' | translate }}
			<svg-icon
				class="pointer-events-none size-4"
				src="assets/icons/icon-cross.svg"
			/>
		</button>
	}
	<ng-content />
</dialog>
